import React from 'react'

const Actions = (props) => {
    const { title, handle, head, loader, message, messagetype } = props
    
    return (
        <div className='main-container'>
            <div className='button-container'>
                <h4>{head}</h4>
                {title && <button className='button-4' disabled={loader} onClick={handle}>{title} </button>}
                {loader && <div><div className='loader'></div></div>}
                
            </div>
            {message && <div className={`${messagetype|| "info"}`}>{message}</div>}
            {props.component && <div children={props.component}></div>}
        </div>
    )
}

export default Actions